import { queryOptions } from '@tanstack/vue-query'
import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack'

export const useGetWaitlistQuery = (
  userId: ComputedRef<string | undefined>,
  options?: NitroFetchOptions<NitroFetchRequest>
) => {
  const { $waitlistRepository } = useNuxtApp()

  return queryOptions({
    queryKey: getWaitlistQueryKey(userId),
    queryFn: async () => {
      const data = await $waitlistRepository.index(unref(options))
      updateLocalStorageWaitlistedIds(data)
      return data
    },
  })
}
